/* eslint-disable */
const colors = {
  cellbg1: "rgba(222, 238, 249, 255)",
  cellbg2: "rgba(237, 244, 213, 255)",
  cellbg3: "rgba(249, 216, 200, 255)",
  cellbg4: "rgba(251, 236, 209, 255)",
  cellbg: [
    "rgba(222, 238, 249, 255)",
    "rgba(237, 244, 213, 255)",
    "rgba(249, 216, 200, 255)",
    "rgba(251, 236, 209, 255)",
  ],
  background: '#1F0808',
  clear: 'rgba(0,0,0,0)',
  facebook: '#3b5998',
  transparent: 'rgba(0,0,0,0)',
  silver: '#F7F7F7',
  steel: '#CCCCCC',
  error: 'rgba(200, 0, 0, 0.8)',
  ricePaper: 'rgba(255,255,255, 0.75)',
  frost: '#D8D8D8',
  cloud: 'rgba(200,200,200, 0.35)',
  windowTint: 'rgba(0, 0, 0, 0.4)',
  panther: '#161616',
  charcoal: '#595959',
  coal: '#2d2d2d',
  bloodOrange: '#fb5f26',
  snow: 'white',
  ember: 'rgba(164, 0, 48, 0.5)',
  fire: '#e73536',
  drawer: 'rgba(30, 30, 29, 0.95)',
  eggplant: '#251a34',
  teal: 'teal',
  border: '#483F53',
  banner: '#5F3E63',
  text: '#E0D7E5',
  disabled: '#666666',
}

export default colors
